




































































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
    // Form elements
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    ServerError: () => import('@/components/forms/ServerError.vue'),
    LanguageSelector: () => import('@/components/parts/LanguageSelector.vue'),
  },
})
export default class PageDieselTaxesShow extends Vue {
  i18n: string = 'views.diesel-taxes.show';

  @Getter('diesel-tax/viewing') dieselTax?: DieselTax;

  @Getter('workspace/selected') workspace!: Workspace;

  @Action('diesel-tax/create') createDieselTax!: ({ data, workspaceId }: { data: DieselTaxCreateData; workspaceId: number }) => Promise<DieselTax>;

  @Action('diesel-tax/update') updateDieselTax!: ({ id, data, workspaceId }: { id: number; data: DieselTaxUpdateData; workspaceId: number }) => Promise<DieselTax>;

  @Action('diesel-tax/delete') deleteDieselTax!: (payload: { id: number; workspaceId: number }) => Promise<DieselTax>;

  $refs!: Vue['$refs'] & {
    dieselTaxForm: FormClass;
    deleteForm: FormClass;
  };

  formLoaded: boolean = false;

  payload: DieselTaxCreateData = {
    country: '',
    percentage: 0,
  };

  popupDeleteDieselTax: boolean = false;

  get dieselTaxCountries() {
    return ['BE', 'NL'];
  }

  handleSubmit() {
    let func: string = 'updateDieselTax';
    if (!this.dieselTax?.id) {
      func = 'createDieselTax';
    }

    // @ts-ignore
    this[func]({ id: this.dieselTax?.id, data: this.payload, workspaceId: this.workspace.id })
      .then((dieselTax: DieselTax) => {
        this.$refs.dieselTaxForm.handleSuccess();
        if (func === 'createDieselTax' && this.dieselTax!.id) {
          this.$router.push({ name: 'diesel-tax-detail', params: { id: `${this.dieselTax!.id}` } });
        }
      })
      .catch((e: ErrorResponse) => this.$refs.dieselTaxForm.handleErrors(e));
  }

  handleDelete() {
    if (this.dieselTax?.id) {
      this.deleteDieselTax({ id: this.dieselTax.id, workspaceId: this.workspace.id })
        .then(() => {
          this.popupDeleteDieselTax = false;
          this.$refs.deleteForm.handleSuccess();
          this.$router.push({ name: 'diesel-taxes' });
        })
        .catch((e: ErrorResponse) => this.$refs.deleteForm.handleErrors(e));
    }
  }

  @Watch('dieselTax', { immediate: true, deep: true })
  handleDieselTaxChanged(val: DieselTax) {
    if (!val) {
      return undefined;
    }

    // @ts-ignore
    this.payload = structuredClone(val);
  }

  @Watch('workspace')
  workspaceChanged(val: Workspace) {
    this.$router.push({ name: 'diesel-taxes' });
  }
}
